
<div class="card card-report">
  <div class="card-header">
    <h5 class="title">Contractor Competency Report</h5>
  </div>

  <div class="card-body card-report__overflow">
    <div class="row">
      <div class="col-md-12">
        <p>Report showing contractors with their competency expiry dates</p>
      </div>
    </div>
  </div>

  <div class="card-report__actions">
    <button type="button" [disabled]="!siteOwnerId" (click)="generateReport()" class="btn btn-success btn-round">
      <strong>Generate Report</strong>
    </button>
  </div>
  
</div>
